import dashboardApi from '@/api/dashboard'

const dashboard={
    namespaced:true,
    state:{
        sale:{},
        saleLoading:false,
        student:{},
        studentLoading:false,
        lesson:{},
        lessonLoading:false,
        studyLesson:{},
        studyLessonLoading:false
    },
    mutations:{
        setSaleLoading:(state,data)=>[
            state.saleLoading=data
        ],
        setSale:(state,data)=>{
            state.sale=data
        },
        setStudentLoading:(state,data)=>[
            state.studentLoading=data
        ],
        setStudent:(state,data)=>{
            state.student=data
        },
        setLessonLoading:(state,data)=>[
            state.lessonLoading=data
        ],
        setLesson:(state,data)=>{
            state.lesson=data
        },
        setStudyLessonLoading:(state,data)=>[
            state.studyLessonLoading=data
        ],
        setStudyLesson:(state,data)=>{
            state.studyLesson=data
        }
    },
    actions:{
        async GetSale({ commit }){
            commit('setSaleLoading',true)
            const rep=await dashboardApi.getSale()
            commit('setSale',rep.result)
            commit('setSaleLoading',false)
        },
        async GetStudents({ commit }){
            commit('setStudentLoading',true)
            const rep=await dashboardApi.getStudents()
            commit('setStudent',rep.result)
            commit('setStudentLoading',false)
        },
        async GetLessons({ commit }){
            commit('setLessonLoading',true)
            const rep=await dashboardApi.getLessons()
            commit('setLesson',rep.result)
            commit('setLessonLoading',false)
        },
        async GetStudyLessons({ commit }){
            commit('setStudyLessonLoading',true)
            const rep=await dashboardApi.getStudyLessons()
            commit('setStudyLesson',rep.result)
            commit('setStudyLessonLoading',false)
        }
    }
}

export default dashboard